/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-12-15 20:13:52
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-19 11:33:21
 */
const BASE_URL = '/lishui-gov'
const BASE = '/dev-api'
import request from '@/common/api/request'
// 企业认证列表页列表
export const listByPage = params =>
  request(BASE_URL + '/govEntIntermediary/listByPage', { params })
// 企业认证详情
export const entIntermediaryDetail = params =>
  request(BASE_URL + '/govEntIntermediary/govEntIntermediaryDetail', { params })
// 审核
export const insertRecords = params =>
  request.post(BASE_URL + '/govExam/insertRecords', params)
// 审核记录
export const listRecords = params =>
  request(BASE_URL + '/govExam/listRecords', { params })
// 启用禁用
export const updateIsOpen = data =>
  request.post(BASE_URL + '/govEntIntermediary/updateIsOpen', data)
// 机构导出
export const downloadEntIntermediary = params =>
  request.downLoad(
    BASE_URL + '/govEntIntermediary/downloadEntIntermediary',
    params
  )

// 企业认证详情 机构审核-审核详情中新增的接口-替换上面的 entIntermediaryDetail -具体问承晓
export const entIntermediaryDetail2 = params =>
  request(BASE_URL + '/govEntCommonIntermediary/govEntIntermediaryDetail2', {
    params
  })
// 服务企业认证详情 机构审核-审核详情中新增的接口-替换上面的 entIntermediaryDetail -具体问日鑫
export const entIntermediaryDetail3 = params =>
  request(BASE_URL + '/govEntIntermediary/govEntIntermediaryDetail3', {
    params
  })
// 查询文件附件
export const getOperation = params =>
  request(BASE_URL + '/uploadFileData/getOperation', { params })

// 文件上传
export const uploadFileByContentType =
  process.env.VUE_APP_BASE_API + BASE_URL + '/api/file/uploadFileByContentType'
// export const insertOrUpdateOperation =
//   process.env.VUE_APP_BASE_API +
//   BASE_URL +
//   '/uploadFileData/insertOrUpdateOperation'
// 新增编辑附件
export const insertOrUpdateOperation = data =>
  request.post(BASE_URL + '/uploadFileData/insertOrUpdateOperation', data)
// 删除附件
export const deleteOperation = params =>
  request(BASE_URL + '/uploadFileData/deleteOperation', { params })

// 服务机构退回操作
export const instBackAuth = data => request.post(BASE_URL + '/govEntIntermediary/backServerAuthen', data)
// 普通机构退回操作
export const commonInstBackAuth = data => request.post(BASE_URL + '/govEntCommonIntermediary/backServerAuthen', data)
// 查询机构情况
export const showGoodsAndOrderNum = params => request.get(BASE_URL + '/govEntIntermediary/showGoodsAndOrderNum', params)
